import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from "../../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalService } from "../../../../common/services/global.service";
import { GlobalFunctionService } from "../../../../common/services/global-function.service";
import { Store } from '@ngrx/store';
import { planModified } from '../../../../store/senAppProjects.action';
import { SC_Input } from '../../../../common/input/SC_Input';
import { Observable } from 'rxjs';

@Component({
  selector: 'sen-app-import-plan',
  templateUrl: './import-plan.component.html',
  styleUrls: ['./import-plan.component.scss']
})
export class ImportPlanComponent implements OnInit {
  selectedPlanImport: any;
  planSearchResults: any[];
  selectedProject$: Observable<any[]>;

  constructor(public dialogRef: MatDialogRef<ImportPlanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public global: GlobalVariableService,
    private store: Store<any>,
    public globalService: GlobalService,
    public globalFunction: GlobalFunctionService
  ) {
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
  }

  ngOnInit(): void {
  }

  importPlanSelect(plan: any) {
    this.planSearchResults.map(p => p.duplicate = false)
    this.selectedPlanImport = plan;
    if (this.globalFunction.checkRoofPlayNameExist(plan.name)) {
      this.selectedPlanImport.duplicate = true;
    }
  }

  closeDialogue(action: boolean) {
    if (action) {
      this.importPlan(action)
    } else {
      this.dialogRef.close(action);
    }
  }

  importPlan(action: boolean) {
    const qParam = {
      cmd: this.global.ProjectRoofPlanImport,
      projectID: SC_Input.sProject.selectedProject.id,
      roofPlanID: this.selectedPlanImport.id,
      roofPlanName: this.selectedPlanImport.name
    };
    this.globalService.getData(qParam).subscribe((data: any) => {
      if (data && data.ok) {
        this.dialogRef.close(action);
        this.store.dispatch(planModified());
      }
    });
  }

  planSearchCall(event: any) {
    this.selectedPlanImport = null;
    if (event.target.value) {
      const qParam = {
        cmd: this.global.RoofPlanSearch,
        projectID: SC_Input.sProject.selectedProject.id,
        name: event.target.value
      }
      this.globalService.getData(qParam).subscribe((data: any) => {
        if (data && data.ok) {
          this.planSearchResults = data.ok.data.roofPlans;
        } else {
          this.planSearchResults = [];
        }
      });
    }
  }
}
